import { render, staticRenderFns } from "./PesquisaFiltroCertificacao.vue?vue&type=template&id=53bd9b00&scoped=true"
import script from "./PesquisaFiltroCertificacao.vue?vue&type=script&lang=js"
export * from "./PesquisaFiltroCertificacao.vue?vue&type=script&lang=js"
import style0 from "./PesquisaFiltroCertificacao.vue?vue&type=style&index=0&id=53bd9b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd9b00",
  null
  
)

export default component.exports